{
  "el": {
    "ai": {
      "assistant": {
        "all_projects": "Όλα τα έργα",
        "cap": {
          "action": "Έναρξη νέας συνομιλίας",
          "message": "Έφτασες στο όριο συνομιλιών."
        },
        "empty_state": {
          "subtitle": "Ρώτησέ με οτιδήποτε για τους πελάτες σου",
          "title": "Πώς μπορώ να σε βοηθήσω;"
        },
        "errors": {
          "budget_reached": "Ο προϋπολογισμός AI αυτού του μήνα εξαντλήθηκε. Επικοινώνησε με τη Ziggu για να τον αυξήσεις.",
          "generic": "Κάτι πήγε στραβά. Δοκίμασε ξανά."
        },
        "history": {
          "empty": "Δεν υπάρχουν ακόμα προηγούμενες συνομιλίες",
          "title": "Προηγούμενες συνομιλίες"
        },
        "input": {
          "disclaimer": "Τα αποτελέσματα ενδέχεται να μην είναι ακριβή. Επαλήθευε πάντα τις σημαντικές πληροφορίες.",
          "hint": "Enter για αποστολή · Shift+Enter για νέα γραμμή",
          "placeholder": "Ρώτησε για τους πελάτες σου..."
        },
        "name": "Ziggy",
        "suggestions": {
          "help_notifications": "Πώς ρυθμίζω τις ειδοποιήσεις;",
          "help_project_settings": "Πού βρίσκω τις ρυθμίσεις έργου;",
          "open_decisions": "Ποιες αποφάσεις είναι ακόμα ανοιχτές;",
          "unassigned_units": "Ποια ακίνητα δεν έχουν ακόμα πελάτη;"
        },
        "support_cta": {
          "action": "Επικοινωνία με την υποστήριξη",
          "prompt": "Δεν βρήκες την απάντηση που έψαχνες;"
        }
      },
      "settings": {
        "budget": {
          "description": "Μηνιαίο ανώτατο όριο κόστους για τη χρήση AI (δοκιμαστική φάση). Επανυπολογίζεται με βάση τη χρήση tokens σε όλες τις συνομιλίες αυτόν τον μήνα.",
          "free_label": "Δωρεάν προϋπολογισμός",
          "override_help": "Άφησέ το κενό για να χρησιμοποιηθεί το ποσό του πακέτου ({amount}).",
          "override_label": "Προσαρμοσμένος δωρεάν προϋπολογισμός",
          "paid_label": "Πληρωμένος προϋπολογισμός",
          "save": "Αποθήκευση",
          "title": "Μηνιαίος προϋπολογισμός",
          "total_label": "Συνολικός προϋπολογισμός",
          "usage_label": "Χρήση αυτόν τον μήνα",
          "use_package_amount": "Χρήση ποσού πακέτου"
        },
        "description": "Διαμόρφωση για λειτουργίες AI στον οργανισμό σου.",
        "title": "Ρυθμίσεις AI",
        "usage": {
          "description": "Πόσο από το όριο AI αυτού του μήνα έχει χρησιμοποιηθεί. Στο 100% οι λειτουργίες AI σταματούν μέχρι να ανανεωθεί το όριο τον επόμενο μήνα.",
          "title": "Χρήση AI"
        }
      },
      "ticket_assistant": {
        "actions": {
          "adjust": "Προσαρμογή",
          "ask": "Αποστολή ερώτησης",
          "draft": "Σύνταξη απάντησης",
          "draft_empty": "Δεν υπάρχουν ακόμη μηνύματα για απάντηση",
          "follow_up": "Συμπληρωματική",
          "follow_up_stop": "Διακοπή συμπληρωματικής",
          "new": "Νέα ερώτηση",
          "summary": "Σύνοψη συνομιλίας",
          "summary_empty": "Δεν υπάρχουν ακόμη μηνύματα για σύνοψη",
          "use_as_reply": "Χρήση ως απάντηση"
        },
        "adjusting_draft": "Προσαρμογή αυτού του πρόχειρου",
        "beta": "Beta",
        "budget": {
          "description": "Ο προϋπολογισμός AI αυτού του μήνα εξαντλήθηκε. Οι προηγούμενες απαντήσεις παραμένουν διαθέσιμες.",
          "request": "Εξαντλήσαμε τον προϋπολογισμό AI αυτού του μήνα και θέλουμε να τον αυξήσουμε.",
          "request_low": "Έχουμε σχεδόν εξαντλήσει τον προϋπολογισμό AI αυτού του μήνα και θέλουμε να τον αυξήσουμε.",
          "title": "Ο προϋπολογισμός AI εξαντλήθηκε",
          "warn": "Χρησιμοποιήθηκε το {percent}% του προϋπολογισμού AI αυτού του μήνα."
        },
        "cap": "Αυτή η συνομιλία έχει μεγαλώσει. Κάνε καλύτερα μια νέα ερώτηση.",
        "collapse": "Απόκρυψη βοηθού",
        "conversation": "Συνομιλία",
        "digest": {
          "decisions_open": "καμία ανοιχτή απόφαση | 1 ανοιχτή απόφαση | {count} ανοιχτές αποφάσεις",
          "installments_unpaid": "καμία απλήρωτη δόση | 1 απλήρωτη δόση | {count} απλήρωτες δόσεις",
          "issues_open": "καμία ανοιχτή παρατήρηση | 1 ανοιχτή παρατήρηση | {count} ανοιχτές παρατηρήσεις",
          "nothing_open": "Τίποτα σε εκκρεμότητα για αυτό το ακίνητο",
          "overdue": "{count} εκπρόθεσμες | {count} εκπρόθεσμη | {count} εκπρόθεσμες",
          "title": "Με μια ματιά"
        },
        "earlier_answers": "Προηγούμενες απαντήσεις",
        "empty": "Ρώτησε κάτι για αυτή τη συνομιλία ή ξεκίνα με μία από αυτές.",
        "expand": "Εμφάνιση βοηθού",
        "following_up": "Συμπληρωματική σε αυτή την απάντηση",
        "footer": "Ορατό μόνο σε εσένα. Οι απαντήσεις δημιουργούνται από AI και μπορεί να περιέχουν λάθη.",
        "input": {
          "adjust_draft": "Προσάρμοσε αυτό το πρόχειρο, π.χ. πιο σύντομο ή πιο επίσημο",
          "follow_up": "Κάνε μια συμπληρωματική ερώτηση",
          "label": "Η ερώτησή σου",
          "placeholder": "Ρώτησε για αυτή τη συνομιλία"
        },
        "links": {
          "aftercare": "Παρατηρήσεις",
          "decisions": "Αποφάσεις",
          "financials": "Οικονομικά"
        },
        "placeholders": {
          "confirm": {
            "accept": "Αποστολή ούτως ή άλλως",
            "header": "Αποστολή με κενά πεδία;",
            "message": "Ο βοηθός άφησε 1 πεδίο χωρίς συμπλήρωση σε αυτή την απάντηση. | Ο βοηθός άφησε {count} πεδία χωρίς συμπλήρωση σε αυτή την απάντηση."
          },
          "remaining": "1 πεδίο προς συμπλήρωση | {count} πεδία προς συμπλήρωση"
        },
        "replace_reply": {
          "confirm": {
            "accept": "Αντικατάσταση",
            "header": "Αντικατάσταση του κειμένου σου;",
            "message": "Το πρόχειρο αντικαθιστά το κείμενο στο πεδίο απάντησης."
          }
        },
        "suggestions": {
          "history": "Ποιο είναι το ιστορικό με αυτόν τον πελάτη;",
          "issues_open": "Πόσες παρατηρήσεις παραμένουν ανοιχτές;",
          "undecided": "Τι δεν έχει αποφασίσει ακόμη αυτός ο πελάτης;"
        },
        "thinking": "Ο βοηθός εργάζεται...",
        "title": "Βοηθός"
      }
    }
  }
}
